import React, { useState } from 'react';
import { Model } from '@features/recipes/types';
import { Tabs, Card, Row, Col, Divider, Space, Form, Button } from 'antd';
import { OctoButton } from '@components/form';

const { Meta } = Card;
const { TabPane } = Tabs;

interface ModelSelector {
  selectModel: any;
  cancel: any;
  models: Model[];
}

const ModelSelector = ({ selectModel, cancel, models }: ModelSelector) => {
  const [activeModel, setActiveModel] = useState<Model>();
  const appModels = models.filter((m) => m.type === 'app');
  const octoModels = models.filter((m) => m.type === 'octo');
  const communityModels = models.filter((m) => m.type === 'community');
  return (
    <div>
      <h3 style={{ margin: 4, color: '#444' }}>Models</h3>
      <Divider />

      <h4 style={{ marginBottom: 20, color: '#444', fontWeight: 'bold' }}>
        Choose a model for your recipe
      </h4>
      <Tabs defaultActiveKey="1" type="card">
        <TabPane tab="Your models" key="1">
          <SectionCards models={appModels} onCardClick={setActiveModel} />
        </TabPane>
        <TabPane tab="Octolis models" key="2">
          <SectionCards models={octoModels} onCardClick={setActiveModel} />
        </TabPane>
        <TabPane tab="Community models" key="3">
          <SectionCards models={communityModels} onCardClick={setActiveModel} />
        </TabPane>
      </Tabs>

      <Divider />
      <div style={{ height: 200 }}>
        <h4 style={{ marginBottom: 20, color: '#444', fontWeight: 'bold' }}>Model details</h4>
        {activeModel ? (
          <div style={{ border: '2px solid #f1f1f1' }}>
            <h4 style={{ color: '#444', fontWeight: 'bold' }}>{activeModel.title}</h4>
            <p style={{ color: '#c6c6c6' }}>{activeModel.description}</p>
            <p style={{ marginTop: 10 }}>{activeModel.query}</p>
          </div>
        ) : (
          <div>
            <p> Please select a model </p>
          </div>
        )}
      </div>
      <Row>
        <Col span={18} style={{ textAlign: 'left' }} />
        <Col span={6} style={{ textAlign: 'right' }}>
          <Space direction="horizontal">
            <Form.Item>
              <Button
                type="text"
                className="octolis__secondary-btn"
                disabled={!activeModel}
                onClick={() => {
                  cancel();
                }}
              >
                Cancel
              </Button>
            </Form.Item>
            <OctoButton
              buttonConfig={{ type: 'text' }}
              popConfirmConfig={{
                title: `Are you sure, it will replace your current query`,
                okText: `yes`,
                cancelText: `no`,
              }}
              label="Use model"
              disabled={!activeModel}
              onClick={() => {
                selectModel(activeModel);
              }}
              triggerClassName="octolis__primary-btn"
            />
          </Space>
        </Col>
      </Row>
    </div>
  );
};
const SectionCards = ({ models, onCardClick }: { models: Model[]; onCardClick: any }) => {
  return (
    <Row style={{ height: 400, overflowY: 'scroll', paddingTop: 5 }}>
      {models.map((model, index) => {
        return (
          <Col key={index} style={{ width: '19%', marginLeft: 3, marginBottom: 8 }}>
            <Card
              size={'small'}
              bordered={true}
              hoverable={true}
              onClick={() => onCardClick(model)}
              style={{ height: 160, overflowX: 'clip' }}
              cover={
                <img
                  alt="example"
                  style={{ width: 70, height: 70, padding: 10 }}
                  src="data:image/png;base64,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"
                />
              }
            >
              <Meta title={model.title} description={model.description} />
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};
export default ModelSelector;
